module.exports = __webpack_public_path__ + "static/img/14.134b5db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/14.png
// module id = mr8m
// module chunks = 1